import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import './styles/report.css'

export class MapContainer extends Component {
  render() {
    return (
      <Map
        google={this.props.google}
        zoom={14}
        className='Map'
        initialCenter={
          {
            lat: this.props.lat,
            lng: this.props.lng
          }
        }
      >
          <Marker position={
          {
            lat: this.props.lat,
            lng: this.props.lng
          }
        }></Marker>
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyBh5yarJQ7by-D5MhU2vBYtj0cOvLxaXxI'
})(MapContainer);